/**
 *
 * @author Aleynikov Boris <aleynikov.boris@gmail.com>.
 */

'use strict';

var app               = require('mag-app'),
    systemPlayer      = require('../system.player'),
    findIndex         = require('array-find-index'),
    isoLangs          = require('cjs-iso-639'),
    subtitlesEncoding = [
        'utf-8',
        'cp1250',
        'cp1251',
        'cp1252',
        'cp1253',
        'cp1254',
        'cp1255',
        'cp1256',
        'cp1257',
        'cp1258',
        'iso8859-1',
        'iso8859-2',
        'iso8859-3',
        'iso8859-4',
        'iso8859-5',
        'iso8859-6',
        'iso8859-7',
        'iso8859-8',
        'iso8859-9',
        'iso8859-10',
        'iso8859-11',
        'iso8859-12',
        'iso8859-13',
        'iso8859-14',
        'iso8859-15',
        'iso8859-16'
    ],
    lastExternalSubtitle;

function makeItem ( icon, text ) {
    return  [
        {
            className: icon
        },
        {
            value: text
        }
    ];
}


function setAspectHandler ( value ) {
    systemPlayer.primary.aspect = value;
}

function setSubtitlesHandler ( track ) {
    if ( typeof track === 'number' || track === null ) {
        systemPlayer.primary.subtitlesPID = track;
        app.playback.subtitles.current = {
            pid: track,
            lang: []
        };
        lastExternalSubtitle = null;
    } else if (track && track.getUri ) {
        lastExternalSubtitle = track;
        track.getUri(function ( error, uri ) {
            if ( !error && uri ) {
                systemPlayer.primary.loadExternalSubtitles(uri);
            } else {
                core.notify({
                    title: gettext('Can not load external subtitle link'),
                    icon: 'alert',
                    type: 'error',
                    timeout: 2000
                });
            }
        });
    } else if ( track && track.uri ) {
        lastExternalSubtitle = track;
        systemPlayer.primary.loadExternalSubtitles(track.uri);
    }
}

function setSubtitlesEncoding ( value ) {
    systemPlayer.subtitlesEncoding = value;
}


module.exports = [
    {
        items:  makeItem('theme-icon theme-icon-aspect', gettext('Aspect')),
        options: [
            {
                title: gettext('Original'),
                value: 0
            },

            {
                title: gettext('Letter box'),
                value: 1
            },

            {
                title: gettext('Pan&Scan'),
                value: 2
            },
            {
                title: gettext('combined'),
                value: 3
            },

            {
                title: gettext('enlarged'),
                value: 4
            },

            {
                title: gettext('optimal'),
                value: 5
            }
        ],
        handler: setAspectHandler,
        getFocusIndex: function () {
            return systemPlayer.primary.aspect;
        },
        description: gettext('Change video conversation mode')
    },
    {
        items: makeItem('theme-icon theme-icon-subtitles', gettext('Subtitles')),
        description: gettext('Enable/disable or change subtitles for current content playback'),
        handler: setSubtitlesHandler,
        getOptions: function () {
            var result = [
                {
                    value: null,
                    title: gettext('Off')
                }
            ];

            app.playback.subtitles.list.forEach(function ( track ) {
                var title;

                if ( track.lang && track.lang.length && track.lang[0] !== 'und' ) {
                    title = track.lang[0];
                    title = isoLangs['1'][title] || isoLangs['2T'][title] || isoLangs['2B'][title] || [gettext('Track') + ' ' + track.lang[0]];
                    title = title[0];
                } else {
                    title = gettext('Track') + ' ' + track.pid;
                }

                result.push({
                    title: title,
                    value: track.pid
                });
            });

            if ( app.lastPrimaryIntent && app.lastPrimaryIntent.data.subtitles ) {
                app.lastPrimaryIntent.data.subtitles.forEach(function ( external ) {
                    var title;

                    title = external.lang || '';
                    title = isoLangs['1'][title] || isoLangs['2T'][title] || isoLangs['2B'][title] || [''];
                    title = title[0];

                    result.push({
                        title: external.title || title || gettext('External track'),
                        value: external,
                        external: true
                    });


                });
            }

            return result;
        },
        getFocusIndex: function () {
            var result = 0,
                externalSubtitles,
                externalIndex,
                index;

            // systemPlayer.primary.subtitlesTracks do not have findIndex in it's prototype, polyfill not fixing this case
            index = findIndex([].concat(systemPlayer.primary.subtitlesTracks), function ( track ) {
                return track.pid === systemPlayer.primary.subtitlesPID;
            });

            if ( lastExternalSubtitle && app.lastPrimaryIntent && app.lastPrimaryIntent.data.subtitles ) {
                // copy subtitles array because it is link to variable in side app and even findIndex polyfill may broke
                externalSubtitles = app.lastPrimaryIntent.data.subtitles.slice(0);
                externalIndex = findIndex(externalSubtitles, function ( subtitles ) {
                    return subtitles === lastExternalSubtitle;
                });

                if ( externalIndex > -1 ) {
                    index += externalIndex;
                }
            }

            if ( index >= 0 ) {
                result = index + 1;
            }

            if ( !systemPlayer.primary.enableSubtitles ) {
                result = 0;
            }

            return result;
        }
    },
    {
        items: makeItem('theme-icon theme-icon-subtitles', gettext('Subtitles encoding')),
        description: gettext('Encoding which will be used to display external subtitles.'),
        handler: setSubtitlesEncoding,
        options: subtitlesEncoding.map(function ( encoding ) {
            return {
                title: encoding,
                value: encoding
            };
        }),
        getFocusIndex: function () {
            var index = findIndex(subtitlesEncoding, function ( encoding ) {
                return encoding === systemPlayer.subtitlesEncoding;
            });

            return index > -1 ? index : 0;
        }
    }
];
